export const pssImagesUrl = 'https://documents.packhelp.com/product-specification-form/previews';
//# sourceMappingURL=pss-images-url.js.map